import gql from 'graphql-tag'

export const GET_PRODUCT_BRAND_LIST = gql`
  query getProductBrandList($page: Int, $perPage: Int) {
    productBrandList (page: $page, perPage: $perPage) {
      nodes {
        id
        name
      }
    }
  }
`
export default {
  GET_PRODUCT_BRAND_LIST
}
